/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectSlateQueryVariables = {|
  sportId: string,
  gameTypeId: string,
|};
export type SelectSlateQueryResponse = {|
  +slatesForSportAndGameType: ?$ReadOnlyArray<?{|
    +id: string,
    +prettyStartTime: ?string,
    +suffix: ?string,
    +gameType: {|
      +id: string,
      +name: string,
      +isCptMode: boolean,
    |},
    +slatecompetitionSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +competition: {|
            +id: string,
            +homeTeam: ?{|
              +id: string,
              +abbreviation: string,
              +name: ?string,
            |},
            +awayTeam: ?{|
              +id: string,
              +abbreviation: string,
              +name: ?string,
            |},
            +name: ?string,
          |}
        |}
      |}>
    |},
  |}>
|};
export type SelectSlateQuery = {|
  variables: SelectSlateQueryVariables,
  response: SelectSlateQueryResponse,
|};
*/


/*
query SelectSlateQuery(
  $sportId: ID!
  $gameTypeId: ID!
) {
  slatesForSportAndGameType(sportId: $sportId, gameTypeId: $gameTypeId) {
    id
    prettyStartTime
    suffix
    gameType {
      id
      name
      isCptMode
    }
    slatecompetitionSet {
      edges {
        node {
          competition {
            id
            homeTeam {
              id
              abbreviation
              name
            }
            awayTeam {
              id
              abbreviation
              name
            }
            name
          }
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "gameTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sportId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "gameTypeId",
    "variableName": "gameTypeId"
  },
  {
    "kind": "Variable",
    "name": "sportId",
    "variableName": "sportId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "GameTypeType",
  "kind": "LinkedField",
  "name": "gameType",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCptMode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  },
  (v6/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "CompetitionType",
  "kind": "LinkedField",
  "name": "competition",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamType",
      "kind": "LinkedField",
      "name": "homeTeam",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamType",
      "kind": "LinkedField",
      "name": "awayTeam",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectSlateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "slatesForSportAndGameType",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionTypeConnection",
            "kind": "LinkedField",
            "name": "slatecompetitionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateCompetitionType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SelectSlateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SlateType",
        "kind": "LinkedField",
        "name": "slatesForSportAndGameType",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionTypeConnection",
            "kind": "LinkedField",
            "name": "slatecompetitionSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateCompetitionType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4315a2058022cf76e5cd074c90e5a536",
    "id": null,
    "metadata": {},
    "name": "SelectSlateQuery",
    "operationKind": "query",
    "text": "query SelectSlateQuery(\n  $sportId: ID!\n  $gameTypeId: ID!\n) {\n  slatesForSportAndGameType(sportId: $sportId, gameTypeId: $gameTypeId) {\n    id\n    prettyStartTime\n    suffix\n    gameType {\n      id\n      name\n      isCptMode\n    }\n    slatecompetitionSet {\n      edges {\n        node {\n          competition {\n            id\n            homeTeam {\n              id\n              abbreviation\n              name\n            }\n            awayTeam {\n              id\n              abbreviation\n              name\n            }\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f9dd9b8421fd9cfb7d83ac1ce012448';

module.exports = node;
